import template from './settleEasyButton.template.html';
import templateRefer from './settleEasy.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    owner: '<',
    idTicket: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $timeout, $mdDialog, settleEasyService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.destroyWatch = null;

      ctrl.initialize = () => {
        ctrl.contacts = _.filter(ctrl.contacts || [], (c) => !c?.isCompany);
        ctrl.owner = ctrl.owner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isDisabled = ctrl.isDisabled || false;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog.show({
          targetEvent: $event,
          locals: {
            contacts: ctrl.contacts || [],
            owner: ctrl.owner || {},
            idTicket: ctrl.idTicket || ''
          },
          template: templateRefer,
          controllerAs: '$ctrl',
          multiple: true,
          controller(contacts, owner, idTicket) {
            const self = this;
            self.contacts = contacts;
            self.owner = owner;
            self.idTicket = idTicket;
            self.organization = $rootScope.CurrentOrganization;
            self.gainedConsent = false;
            self.errorMessages = [];
            self.hasError = false;
            self.isSubmitted = false;
            self.isLoading = false;

            self.confirm = () => {
              self.errorMessages = [];
              self.hasError = false;
              self.isLoading = true;
              self.isSubmitted = false;
              settleEasyService
                .refer({
                  idTicket: self.idTicket,
                  gainedConsent: self.gainedConsent
                })
                .then((result) => {
                  self.isLoading = false;
                  if (result?.status) {
                    self.isSubmitted = true;
                    $timeout(() => {
                      $mdDialog.hide();
                    }, 5000);
                  } else {
                    self.hasError = true;
                    if (result?.errors?.length) {
                      const len = result?.errors?.length || 0;
                      for (let e = 0; e < len; e += 1) {
                        const error = result?.errors[e];
                        const message = error?.label
                          ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                          : error?.message || error || '';
                        self.errorMessages.push(message);
                      }
                    } else {
                      self.errorMessages.push(result?.errorMessage);
                    }
                    self.errorMessages.unshift('Settle Easy errors:');
                  }
                });
            };

            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        if (ctrl.destroyWatch) {
          ctrl.destroyWatch();
        }
      };
    }
  }
};
